import React from 'react'
import { Icon } from '@st-operations/uikit/src/v2'
import format from '@st-operations/uikit/lib/format'
import { Fragment } from 'react'

const PIE_CHART_BACKGROUND_COLORS = [
  '#8C3A6D',
  '#146A59',
  '#B81C0C',
  '#F7DB71',
  '#0CB2B2',
  '#34158C',
  '#5BAC4D',
]
const PIE_CHART_COLORS = [
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
  '#666666',
  '#FFFFFF',
  '#FFFFFF',
  '#FFFFFF',
]

const getMappedEventIcon = (eventType) =>
  ({
    'Page Views': 'picture',
    Searches: 'search',
    Clicks: 'cursor',
    Other: 'others',
    'Inbound Links': 'externallink',
    'Outbound Links': 'externallink',
    Share: 'share',
    'Ecommerce Page Views': 'cart',
  }[eventType])

const MappedEvents = ({ data }) => {
  const renderMappedEvent = (eventType, index) => {
    return (
      <>
        <div className="de-events__distribution-legend-item">
          <Icon
            className="de-events__distribution-legend-icon"
            icon={getMappedEventIcon(eventType.eventType)}
            width="22px"
            height="22px"
            backgroundColor={PIE_CHART_BACKGROUND_COLORS[index]}
            color={PIE_CHART_COLORS[index]}
          />
          <p>{eventType.eventType}</p>
        </div>
        <p className="de-events__distribution-legend-item">
          {eventType?.users ? format('metric', eventType.users) : ' '}
        </p>
        <p className="de-events__distribution-legend-item">{format('metric', eventType.size)}</p>
        <p className="de-events__distribution-legend-item">{eventType.percentText}</p>
      </>
    )
  }

  return (
    <>
      <div className="de-events__distribution-legend">
        <span className="de-events__distribution-legend-header de-events__distribution-legend-header--type">
          Type
        </span>
        <span className="de-events__distribution-legend-header de-events__distribution-legend-header--percent">
          {data.some((eventType) => eventType.users) ? 'Unique Users' : ' '}
        </span>
        <span className="de-events__distribution-legend-header de-events__distribution-legend-header--percent">
          Unique Counts
        </span>
        <span className="de-events__distribution-legend-header de-events__distribution-legend-header--percent">
          Distribution
        </span>
        <For each="eventType" of={data} index="index">
          <Fragment key={eventType.eventType}>{renderMappedEvent(eventType, index)}</Fragment>
        </For>
      </div>
    </>
  )
}

export default MappedEvents
